var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading loading--inline"},[_c('div',{staticClass:"vs-con-loading__container loading-example",class:{'activeLoading':true},attrs:{"id":"loading-corners"}}),_c('div',{staticClass:"effect-1 effects"}),_c('div',{staticClass:"effect-2 effects"}),_c('div',{staticClass:"effect-3 effects"})])
}
var staticRenderFns = []

export { render, staticRenderFns }